const tariffSandboxRoute = {
  name: 'TariffSandbox',
  path: '/administration/tariff-sandbox',
  component: () => import('@/views/TariffSandbox.vue'),
} as const;

type TariffSandboxRoute = typeof tariffSandboxRoute;

/**
 * The tenants the tariff sandbox route is created on: enercity, and local development.
 */
const tariffSandboxTenants = new Set(['enercity', 'local']);

/**
 * Yields the tariff sandbox route only on the tenants it exists on, so everywhere else its URL matches no route at all.
 */
export function buildTariffSandboxRoutes(tenantName: string): TariffSandboxRoute[] {
  return tariffSandboxTenants.has(tenantName) ? [tariffSandboxRoute] : [];
}
